import React from 'react';
import { ReactComponent as Logo } from '../Logo.svg';

// Components
const Header = () => (
  <header className="header">
    <Logo />
  </header>
);

export default Header;